@if(!templateForPermitForm){
  <div
  class="text-red"
  *ngIf="errorMessage !== null"
  [innerHTML]="errorMessage">
</div>}
@else {
  <div
  class="text-red"
  *ngIf="janusErrorMessage !== null"
  [innerHTML]="janusErrorMessage"
></div>

}


